import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-sm border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 group"
          >
            <span className="w-8 h-8 flex items-center justify-center">
              <i className="ri-heart-pulse-line text-primary-500 text-xl"></i>
            </span>
            <span className="font-heading text-lg font-bold text-foreground-900 whitespace-nowrap group-hover:text-primary-600 transition-colors">
              传教士体位指南
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-6">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`text-sm whitespace-nowrap transition-colors duration-200 ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'text-primary-600 font-semibold'
                    : 'text-foreground-600 hover:text-primary-500'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`text-sm whitespace-nowrap transition-colors duration-200 ${
                location.pathname === '/about'
                  ? 'text-primary-600 font-semibold'
                  : 'text-foreground-600 hover:text-primary-500'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer rounded-lg hover:bg-background-100 transition-colors"
            onClick={() => setIsMobileOpen(!isMobileOpen)}
            aria-label="菜单"
          >
            <i className={`ri-${isMobileOpen ? 'close' : 'menu'}-line text-foreground-800 text-xl`}></i>
          </button>
        </div>

        {isMobileOpen && (
          <div className="md:hidden border-t border-background-200/70 py-4 bg-background-50">
            <div className="flex flex-col gap-2">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2.5 rounded-lg text-sm transition-colors ${
                    location.pathname === `/category/${cat.slug}`
                      ? 'bg-primary-100 text-primary-700 font-semibold'
                      : 'text-foreground-600 hover:bg-background-100'
                  }`}
                >
                  <span className="w-5 h-5 inline-flex items-center justify-center mr-2">
                    <i className={`${cat.icon} text-primary-500`}></i>
                  </span>
                  {cat.name}
                </Link>
              ))}
              <Link
                to="/about"
                className={`px-4 py-2.5 rounded-lg text-sm transition-colors ${
                  location.pathname === '/about'
                    ? 'bg-primary-100 text-primary-700 font-semibold'
                    : 'text-foreground-600 hover:bg-background-100'
                }`}
              >
                关于我们
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}